import { getAgreementData } from '@partiu/api/dashboard/api';
import { IAgreement } from '@partiu/api/dashboard/types';
import { getLanding } from '@partiu/api/landing/api';
import { parseAgreementToTheme, parseAgreementToThemeDash } from '@partiu/api/landing/utils';

export async function slugResolver() {
  let slug = window.location.host.split('.')[0];

  if (slug.includes('localhost')) slug = 'liggarevistas';

  const agreement: IAgreement = await getLanding(slug);
  return parseAgreementToTheme(agreement);
}

export async function slugDashResolver() {
  const agreement: IAgreement = await getAgreementData();

  return parseAgreementToThemeDash(agreement);
}

export async function bookstoreSlugResolver() {
  let slug = window.location.host.split('.')[0];

  if (slug.includes('localhost')) slug = 'liggarevistas';

  const agreement: IAgreement = await getLanding(slug, 'is_bookstore');
  return parseAgreementToTheme(agreement);
}
